import { Component, OnInit } from '@angular/core';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { Store } from '@ngrx/store';
import { QuickSelectionModel, QuickSelectionModelId, SelectionEventModel, TreeItemNode } from '@shared/models/tree-selector.models';
import {StreamsState} from '../../store/reducers/streams.reducer';
import {AddStreamsAction, DeleteStreamsAction, GetStreamsAction} from '../../store/actions/streams.actions';
import {PaymentStream} from '../../../models/payment-stream.model';
import {AddStreamsCommand, DeleteStreamsCommand} from '../../commands/streams.commands';
import {PaymentStreamSetting} from '../../../models/payment-stream-setting.model';
import {getStreams} from '../../store/selectors/streams.selectors';

@Component({
    standalone: false,
    selector: 'lib-app-streams-content',
  templateUrl: './streams-content.component.html',
  styleUrls: ['./streams-content.component.scss']
})
export class StreamsContentComponent implements OnInit {
  streams: PaymentStreamSetting[];
  streamsData$: BehaviorSubject<TreeItemNode[]> = new BehaviorSubject([]);
  streamsQuickSelections$: Observable<QuickSelectionModel[]>;
  constructor(private store: Store<StreamsState>) {
    this.streamsQuickSelections$ = of([
      {
        name: 'All streams',
        id  : QuickSelectionModelId.ALL
      },
      {
        name: 'None',
        id  : QuickSelectionModelId.NONE
      }
    ]);
  }

  ngOnInit() {
    this.store.dispatch(new GetStreamsAction());
    this.store.select(getStreams).subscribe(streams => {
      this.prepareStreamsData(streams);
    });
  }

  prepareStreamsData(streams: PaymentStreamSetting[]) {
    this.streams = streams;
    const streamsSelectorNodes = this.buildStreamsSelectorTree(this.streams);
    this.streamsData$.next(streamsSelectorNodes);
  }

  buildStreamsSelectorTree (streamSettings: PaymentStreamSetting[]) {
    const data: TreeItemNode[] = [];
    streamSettings.forEach(settings => {
      const node = new TreeItemNode();
      node.item = {
        ...settings,
        title: settings.stream.title
      };
      data.push(node);
    });
    return data;
  }

  onStreamSelectionChanged(event: SelectionEventModel) {
    let streams: PaymentStream[];
    if (event.currentTreeNode) {
      streams = [event.currentTreeNode.item.stream];
    } else {
      streams = event.selectedTreeNodes.map(node => new PaymentStream({...node.item.stream}));
    }
    if (event.isCurrentTreeNodeChecked) {
      this.store.dispatch(new AddStreamsAction(new AddStreamsCommand(streams)));
    } else {
      const streamIds: string[] = streams.map(s => s.id);
      this.store.dispatch(new DeleteStreamsAction(new DeleteStreamsCommand(streamIds)));
    }
  }

}
